import { render, staticRenderFns } from "./money-tips.vue?vue&type=template&id=78e43316&"
import script from "./money-tips.vue?vue&type=script&lang=js&"
export * from "./money-tips.vue?vue&type=script&lang=js&"
import style0 from "./money-tips.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports